/**
 * The Pulse check-in is paused while it is reworked for the platform redesign
 * (decision 2026-10-30). While paused, the Team > Check in tab, the check-in
 * banner, the chat and Idag nudges, the first-run hand-off and the
 * /coach/performance/pulse route are all off, regardless of the
 * `show_pulse_check` remote-config flag. Flip this to false to resume; the
 * remote-config flag then decides per environment as before.
 */
export const PULSE_CHECK_IN_PAUSED = true;
